const moment = require('moment-timezone');

import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import UniqueIdGenerator from "../../../../core/utils/uniqueIdGenerator";

import DashboardService from "../../../../core/services/dashboardService";
import WidgetService from "../../../../core/services/widgetService";
import { defaultDateFormat, defaultDateTimeFormat, defaultTimeFormat } from "../../../../core/constants/defaultValues"

import { DateOnlyPicker, DateTimePicker, TimePicker } from "./dateTimePicker.jsx";
import { Variable } from "./variable.jsx";
import { Selection } from "./selection.jsx"
import { variableTypes } from "./constants";
import styles from "./styles.scss";

export class AddSelectionControl extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  componentDidMount() {

    this.$modal = $("#add-selection-control");
    this.$modal.modal({
      dismissible: false
    });
    $(this.refs.container).find("select").material_select();
    document.body.addEventListener('click', this.bodyClickEventHandler);

    // $(this.refs.inputType).on("change", (e) => this.handleChange("inputType", e));
    // $(this.refs.variableType).on("change", (e) => this.handleChange("variableType", e));
  }

  componentDidUpdate() {
    $(this.refs.container).find("select").material_select();
    Materialize.updateTextFields();
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.bodyClickEventHandler);
  }

  bodyClickEventHandler(event) {
    if ($(event.target).parents("#datePickerWrapper").length ||
      $(event.target).parents("#dateTimePickerWrapper").length ||
      $(event.target).parents("#timePickerWrapper").length ||
      $(event.target).parents(".react-datepicker").length) {
    } else {
      $(this.refs.datePickerWrapper).css("display", "none");
      $(this.refs.dateTimePickerWrapper).css("display", "none");
      $(this.refs.timePickerWrapper).css("display", "none");
    }
  }

  getInitialState() {
    const newVariable = this.createNewVariable();
    const newSelection = {
      id: UniqueIdGenerator.id(),
      description: "",
      variables: [{
        id: newVariable.id,
        value: ""
      }]
    };
    return {
      title: "",
      variables: [newVariable],
      selections: [newSelection],
      currentSelectionId: null,
      currentEditingValue: {
        selectionIndex: -1,
        variableId: null,
        value: null
      },
      visibleExp: ""
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.editControlWidget) {
      const metaData = JSON.parse(JSON.stringify(nextProps.editControlWidget.metaData));
      this.originalMetaData = JSON.parse(JSON.stringify(metaData));
      this.setState({
        title: metaData.title,
        variables: metaData.variables,
        selections: metaData.selections,
        currentSelectionId: metaData.currentSelectionId,
        currentEditingValue: {
          selectionIndex: -1,
          variableId: null,
          value: null
        },
        visibleExp: metaData.visible ? metaData.visible.expression : ""
      });
    }
  }

  show() {
    this.$modal.modal("open");
  }

  addVariable() {
    const variables = this.state.variables.slice();
    const newVariable = this.createNewVariable();
    variables.push(newVariable);
    const selections = this.state.selections.map(s => {
      s.variables.push({
        id: newVariable.id,
        value: "",
        timezone: moment.tz.guess()
      });
      return s;
    });
    this.setState({
      variables,
      selections
    });
  }

  createNewVariable() {
    return {
      id: UniqueIdGenerator.id(),
      name: "",
      type: ""
    }
  }

  buildMetaData() {
    const metaData = {
      type: "selection",
      title: this.state.title,
      variables: this.state.variables,
      selections: JSON.parse(JSON.stringify(this.state.selections)),
      currentSelectionId: this.state.currentSelectionId,
      visible: {
        type: variableTypes.EXPRESSION,
        expression: this.state.visibleExp
      }
    };

    if (metaData.currentSelectionId === "") {
      const defaultSelection = this.state.selections.find(s => s.isDefault);
      if (defaultSelection) {
        metaData.currentSelectionId = defaultSelection.id;
      }
    }

    return metaData;
  }

  addOrUpdate() {
    const metaData = this.buildMetaData();
    this.addOrUpdateDashboardVariable(metaData)
      .then(() => {
        if (this.props.editControlWidget) {
          WidgetService.updateWidgetMetaData(this.props.editControlWidget.id, metaData);
          this.publish(InternalEvent.Dashboard.DASHBOARD_VARIABLE_CHANGED, this.state.variables);
          this.publish(InternalEvent.Dashboard.CONTROL_UPDATED, { widgetId: this.props.editControlWidget.id });
        } else {
          this.publish(InternalEvent.Dashboard.CONTROL_ADDED, metaData);
        }
        this.hide();
      });
  }

  addOrUpdateDashboardVariable(metaData) {
    const originalVariableIds = this.originalMetaData ? this.originalMetaData.variables.map(v => v.id) : [];
    const currentVariableIds = this.state.variables.map(v => v.id);
    const variableIdsToRemove = [];
    const currentSelection = this.state.selections.find(s => s.id === metaData.currentSelectionId);
    const variablesToUpdate = {};

    originalVariableIds.forEach(id => {
      if (currentVariableIds.indexOf(id) === -1) {
        variableIdsToRemove.push(id);
      }
    });

    this.state.variables.forEach(v => {
      variablesToUpdate[v.id] = v;
    });

    if (currentSelection) {
      const selection = JSON.parse(JSON.stringify(currentSelection));
      selection.variables.forEach(v => {
        variablesToUpdate[v.id].value = v.value;
      });
    } else {
      const defaultOption = this.state.selections.find(s => s.isDefault);
      defaultOption.variables.forEach(v => {
        variablesToUpdate[v.id].value = v.value;
      });
      metaData.currentSelectionId = defaultOption.id;
    }

    return DashboardService.updateDashboardVariables(variablesToUpdate, variableIdsToRemove);
  }


  addSelection() {
    const selections = this.getSelectionCopy();
    selections.push(this.createNewSelection());
    this.setState({
      selections
    });
  }

  createNewSelection() {
    const selection = {
      id: UniqueIdGenerator.id(),
      description: "",
      variables: []
    };
    selection.variables = this.state.variables.map(v => {
      const selectionVariable = {
        id: v.id
      };
      selectionVariable.value = this.getVariableDefaultValue(v.type);
      if (v.type === variableTypes.DATETIME || v.type === variableTypes.TIME) {
        selectionVariable.timezone = moment.tz.guess();
      }
      return selectionVariable;
    });
    return selection;
  }

  getVariableDefaultValue(variableType) {
    switch (variableType) {
      case variableTypes.DATETIME:
      case variableTypes.DATE:
      case variableTypes.TIME: {
        const date = moment();
        date.set("hour", 0);
        date.set("minute", 0);
        date.set("second", 0);
        date.set("millisecond", 0);
        return date;
      }
    }
  }

  removeVariable(index) {
    const variables = this.state.variables.slice();
    variables.splice(index, 1);
    const selections = this.state.selections.map(s => {
      s.variables.splice(index, 1);
      return s;
    });
    this.setState({
      variables,
      selections
    });
  }

  removeSelection(index) {
    const selections = this.getSelectionCopy();
    selections.splice(index, 1);
    this.setState({
      selections
    });
  }

  handleVariableFieldChange(index, field, value) {
    const newState = {};
    const variables = this.state.variables.slice();
    let selections = this.getSelectionCopy();
    if (field === "type") {
      if (value === variableTypes.DATE) {
        selections = this.setDefaultValue(variables[index].id, this.getVariableDefaultValue(value))
      } else if (value === variableTypes.DATETIME) {
        selections = this.setDefaultValue(variables[index].id, this.getVariableDefaultValue(value), moment.tz.guess())
      } else if (value === variableTypes.TIME) {
        selections = this.setDefaultValue(variables[index].id, this.getVariableDefaultValue(value), moment.tz.guess());
      } else {
        selections = this.setDefaultValue(variables[index].id, "");
      }
    }
    variables[index][field] = value;
    newState.variables = variables;
    newState.selections = selections;
    this.setState(newState);
  }

  setDefaultValue(variableId, value, timezone) {
    const selections = this.getSelectionCopy();
    selections.forEach(selection => {
      selection.variables.forEach(v => {
        if (v.id === variableId) {
          v.value = value;
          delete v.timezone;
          if (timezone) {
            v.timezone = timezone;
          }
        }
      })
    });
    return selections;
  }

  handleSelectionFieldChange(index, field, value) {
    let selections = this.getSelectionCopy();
    if (field === "isDefault" && value) {
      selections = selections.map((s, i) => {
        if (i !== index) {
          s.isDefault = false;
        }
        return s;
      });
    }
    selections[index][field] = value;

    this.setState({
      selections
    });
  }

  getSelectionCopy() {
    return this.state.selections.slice();
  }

  handleVariableValueChange(selectionIndex, variableIndex, value) {
    const variable = this.state.variables[variableIndex];
    const selections = this.getSelectionCopy();

    if (variable.type === variableTypes.EXPRESSION) {
      // value will be set after evaluate the expression
      selections[selectionIndex].variables[variableIndex].expression = value;
    } else {
      selections[selectionIndex].variables[variableIndex].value = value;
    }

    this.setState({
      selections
    });
  }

  handleTitleChange(value) {
    this.setState({
      title: value
    });
  }

  hide() {
    this.$modal.modal("close");
    this.setState(this.getInitialState());
  }

  getVariable(variableId) {
    return this.state.variables.find(v => v.id === variableId);
  }

  editDate(event, selectionIndex, variable) {
    this.setState({
      currentEditingValue: {
        selectionIndex,
        variableId: variable.id,
        value: variable.value,
        format: variable.dateTimeFormat || defaultDateFormat
      }
    });
    const eventTargetOffset = $(event.currentTarget).offset();
    const containerOffset = $(this.refs.container).offset();
    $(this.refs.datePickerWrapper).css({
      top: eventTargetOffset.top - containerOffset.top - 85,
      left: eventTargetOffset.left - containerOffset.left - 50,
      display: "block"
    });
  }

  editTime(event, selectionIndex, variable) {
    this.setState({
      currentEditingValue: {
        selectionIndex,
        variableId: variable.id,
        value: variable.value,
        timezone: variable.timezone,
        format: variable.dateTimeFormat || defaultTimeFormat
      }
    });
    const eventTargetOffset = $(event.currentTarget).offset();
    const containerOffset = $(this.refs.container).offset();
    $(this.refs.timePickerWrapper).css({
      top: eventTargetOffset.top - containerOffset.top - 85,
      left: eventTargetOffset.left - containerOffset.left - 150,
      display: "block"
    });
  }

  editDateTime(event, selectionIndex, variable) {
    this.setState({
      currentEditingValue: {
        selectionIndex,
        variableId: variable.id,
        value: variable.value,
        timezone: variable.timezone,
        format: variable.dateTimeFormat || defaultDateTimeFormat
      }
    });
    const eventTargetOffset = $(event.currentTarget).offset();
    const containerOffset = $(this.refs.container).offset();
    $(this.refs.dateTimePickerWrapper).css({
      top: eventTargetOffset.top - containerOffset.top - 85,
      left: eventTargetOffset.left - containerOffset.left - 230,
      display: "block"
    });
  }

  handleDateChange(date) {
    const selections = this.getSelectionCopy();
    selections.forEach((selection, i) => {
      if (i === this.state.currentEditingValue.selectionIndex) {
        selection.variables.forEach(v => {
          if (v.id === this.state.currentEditingValue.variableId) {
            v.value = date;
          }
        });
      }
    });
    this.setState({
      selections
    });
    $(this.refs.datePickerWrapper).css("display", "none");
  }

  handleDateTimeChange(date, time, timezone) {
    const selections = this.getSelectionCopy();
    const currentEditingValue = this.state.currentEditingValue;
    selections.forEach((selection, i) => {
      if (i === this.state.currentEditingValue.selectionIndex) {
        selection.variables.forEach(v => {
          if (v.id === this.state.currentEditingValue.variableId) {
            let newDateStr;
            if (date) {
              newDateStr = date.format("YYYY-MM-DDT") + v.value.format("HH:mm:ss.SSS") + v.value.format("Z");
              v.value = moment.tz(newDateStr, v.timezone);
            }
            if (time) {
              const timeStr = this.replaceAt(time, 8, ".");
              newDateStr = v.value.format("YYYY-MM-DDT") + timeStr + v.value.format("Z");
              const newMoment = moment.tz(newDateStr, v.timezone);
              if (newMoment.format() !== "Invalid date") {
                v.value = newMoment;
              }
            }
            if (timezone) {
              newDateStr = v.value.format("YYYY-MM-DDTHH:mm:ss.SSS");
              v.value = moment.tz(newDateStr, timezone);
              v.timezone = timezone;
              currentEditingValue.timezone = v.timezone;
            }
            currentEditingValue.value = v.value;
          }
        });
      }
    });
    this.setState({
      selections,
      currentEditingValue
    });
  }

  replaceAt(string, index, replacement) {
    return string.substr(0, index) + replacement + string.substr(index + replacement.length);
  };

  render() {
    const variables = this.state.variables.map((v, i) =>
      <Variable variable={v} index={i}
        onFieldChange={this.handleVariableFieldChange}
        onRemove={this.removeVariable} key={i} />);

    const selectionVariableNames = this.state.variables.map((v, i) => <th key={i}>{v.name}</th>);
    const selections = this.state.selections.map((s, i) =>
      <Selection selection={s} selectionIndex={i}
        getVariable={this.getVariable}
        onFieldChange={this.handleSelectionFieldChange}
        onVariableValueChange={this.handleVariableValueChange}
        editDate={this.editDate}
        editDateTime={this.editDateTime}
        editTime={this.editTime}
        onRemove={this.removeSelection} key={i} />);
    const title = this.props.editControlWidget ? "Edit Selection Control Widget" : "Add Selection Control Widget";
    return (
      <div className={["modal", styles.modalContainer].join(" ")} id="add-selection-control" ref="container">
        <div style={{ overflow: "hidden" }}>
          <div className="modal-content">
            <h4 className={styles.title}>{title}</h4>
            <div style={{ display: "flex" }}>
              <div className="input-field" style={{ width: "300px", marginRight: '50px' }}>
                <input id="widget-title" type="text"
                  value={this.state.title}
                  onChange={e => this.handleTitleChange(e.target.value)} />
                <label htmlFor="widget-title">Widget Title</label>
              </div>
              <div className="input-field" style={{ width: "300px" }}>
                <input type="text" value={this.state.visibleExp} name="visibleExp"
                  onChange={e => this.setState({ visibleExp: e.target.value })} />
                <label htmlFor="visibleExp">Visibility</label>
              </div>
            </div>

            <table className="bordered">
              <thead>
                <tr>
                  <th>Variable Name</th>
                  <th style={{ width: "250px" }}>Variable Type</th>
                  <th style={{ width: "150px" }}>Format</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {variables}
              </tbody>
            </table>
            <div className={styles.add}>
              <i className="material-icons"
                onClick={this.addVariable}>add_circle_outline</i>
            </div>
            <table className="bordered">
              <thead>
                <tr>
                  <th>Default</th>
                  <th>Selection Description</th>
                  {selectionVariableNames}
                  <th />
                </tr>
              </thead>
              <tbody>
                {selections}
              </tbody>
            </table>
            <div className={styles.add}>
              <i className="material-icons"
                onClick={this.addSelection}>add_circle_outline</i>
            </div>
            <div className={styles.datePickerWrapper} ref="datePickerWrapper" id="datePickerWrapper">
              <DateOnlyPicker date={this.state.currentEditingValue.value}
                format={this.state.currentEditingValue.format}
                onDateChange={this.handleDateChange} />
            </div>
            <div className={styles.dateTimePickerWrapper} ref="dateTimePickerWrapper" id="dateTimePickerWrapper">
              <DateTimePicker date={this.state.currentEditingValue.value}
                format={this.state.currentEditingValue.format}
                timezone={this.state.currentEditingValue.timezone}
                onDateChange={this.handleDateTimeChange} />
            </div>
            <div className={styles.dateTimePickerWrapper} ref="timePickerWrapper" id="timePickerWrapper">
              <TimePicker date={this.state.currentEditingValue.value}
                timezone={this.state.currentEditingValue.timezone}
                onTimeChange={this.handleDateTimeChange} />
            </div>
          </div>
          <div className="modal-footer">
            <a className="waves-effect waves-light btn-flat"
              onClick={this.addOrUpdate}>{this.props.editControlWidget ? "Update" : "Add"}</a>
            <a className="waves-effect btn-flat" onClick={this.hide}>Cancel</a>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/control-widget/selection-contorl/addSelectionControl.jsx